import script from "./SyncSettingsModalAddProject.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncSettingsModalAddProject.vue?vue&type=script&setup=true&lang=js"

import "./SyncSettingsModalAddProject.vue?vue&type=style&index=0&id=2a6d095c&lang=scss&scoped=true"
import "./SyncSettingsModalAddProject.vue?vue&type=style&index=1&id=2a6d095c&lang=scss"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6d095c"]])

export default __exports__